import axios from "axios";
import { auth } from "../context/AppContext";
import { sendAxiosPost, SERVER_URL } from "./ServerUtil";
import { UserData } from "./FirebaseUtil";

export interface Tier {
    value: number;
    name: string;
    fileAccess: boolean;
    accessTier: number; // 1 = dreaming, 2 = deeper, 3 = deepest, 4 = broken
}

export const TierData: { [key: string]: Tier } = {
    "21956760": { value: 0, name: "Free", fileAccess: false, accessTier: 0 },
    "24117805": { value: 1, name: "Drifting", fileAccess: false, accessTier: 0 },
    "21957345": { value: 2, name: "Dreaming (Early Supporter)", fileAccess: true, accessTier: 1 },
    "22386366": { value: 3, name: "Dreaming (Early Supporter)", fileAccess: true, accessTier: 1 },
    "23656280": { value: 2, name: "Dreaming", fileAccess: true, accessTier: 1 },
    "22386333": { value: 3, name: "Deeper", fileAccess: true, accessTier: 2 },
    "24462891": { value: 4, name: "Deepest", fileAccess: true, accessTier: 3 },
    "25098371": { value: 5, name: "Perfected", fileAccess: true, accessTier: 4 },
};

export const tierIdToName = (tierId: string): string => {
    return TierData[tierId]?.name || "-";
}

const PATREON_CLIENT_ID = "3OsZRkHAMmSkXY3WZLJSjqVNdsLSISYHa0JarHgtSEJ8YigD99I4mm-dSrAcmUZe";
const PATREON_SCOPE = encodeURIComponent("identity identity[email]");

// CHANGE FOR PRODUCTION
//const PATREON_REDIRECT_URI = "http://localhost:3000/auth/patreon/callback";
const PATREON_REDIRECT_URI = "https://ipwd.club/auth/patreon/callback";

export const beginPatreonLink = async () => {
    const firebaseToken = await auth.currentUser?.getIdToken(true);
    const PATREON_STATE = encodeURIComponent(firebaseToken || "");
    const patreonAuthUrl = `https://www.patreon.com/oauth2/authorize?response_type=code&client_id=${PATREON_CLIENT_ID}&redirect_uri=${encodeURIComponent(PATREON_REDIRECT_URI)}&scope=${PATREON_SCOPE}&state=${PATREON_STATE}`;
    window.location.href = patreonAuthUrl;
}

export async function linkPatreonToFirebaseUser(token:string, code: string): Promise<UserData | null> {
    // call server to link patreon
    const response = await sendAxiosPost("/auth/linkPatreon", { token, code, redirectUri: PATREON_REDIRECT_URI });
    if (response?.success) {
        // update our User Data
        const userResponse = await sendAxiosPost("/api/getUserData", null, true);
        return userResponse.data || null;
    }
    else {
        // clear patreon auth callback data
        window.location.href = "/profile"; // Redirect to profile page
    }
    return null;
}

export async function unlinkPatreonAccount(): Promise<boolean> {
    // send the request to your server to unlink patreon
    const response = await sendAxiosPost("/auth/unlinkPatreon", null, true);
    return response?.success || false;
}

